import '../../styles/event_container.css'; // Importez le fichier CSS pour le style
import {MainTitle} from '../ui/Titles';
  import FilteredButtons from '../ui/FilteredButton';
import { useEffect, useState } from "react";
import { listenToMusicEventList } from "../GetServices"

// TODO : Filtres
// TODO : etiquettes par évènements

export const Events = () => {
const [selectedEvent, setSelectedEvent] = useState('');
const [eventList, setEventList] = useState([]);
const now = new Date();

  const eventsItems = [
    { label: 'Tous', value: "" },
    { label: 'Sessions', value: "session" },
    { label: 'Publiques', value: "public" }
  ];

    
    useEffect(() => {
      const unsubscribe = listenToMusicEventList((data) => {
        setEventList(data);
      });
      //unsubscribe permet d'éviter les fuites de mémoire
      return () => unsubscribe();
    }, []);

    // Étape 1 : séparer les événements
    const futureEvents = eventList.filter(event => new Date(event.dateStart || event.date) >= now);
    const pastEvents = eventList.filter(event => new Date(event.dateStart || event.date) < now);
    
    // Étape 2 : trier les événements futurs par date croissante
    futureEvents.sort((a, b) => new Date(a.dateStart || a.date) - new Date(b.dateStart || b.date));

    // Étape 3 : trier les événements passés par date décroissante (optionnel)
    pastEvents.sort((a, b) => new Date(b.dateStart || b.date) - new Date(a.dateStart || a.date));

    // Fusion finale
    const sortedEvents = [...futureEvents, ...pastEvents];

  const filteredEvents = selectedEvent
  ? sortedEvents.filter((event) => event.type === selectedEvent)
  : sortedEvents;

  return (
    <div className="event-container">
        <div className='events_title'>
          <MainTitle title="Evènements"/>
        </div> 
        <div>
        <FilteredButtons items={eventsItems} setSelected={setSelectedEvent} selectedValue={selectedEvent} />
        </div>

        {filteredEvents.map((event) => {
    const isPast = new Date(event.dateStart || event.date) < now; //grise si l'évènements est passé

    return(
        <div 
        key={event.id} 
        className={`event_container ${isPast ? 'past-event' : ''}`}
        >
          <div>
            <img src={event.imageURL} alt="erwan tapparel évènement" className="img_event" />
          </div>
          <div className="event_details">
            <div className="event_title_size"> {event.title} </div>
            
            <div className="event-list-description1"> {event.location} </div>
            <p className="event-list-description3">    
              {event.dateStart.toLocaleDateString("fr-FR", {
                weekday: "short",
                day: "numeric",
                month: "long",
                year: "numeric",
              })} à partir de&nbsp;
              {event.dateStart.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
  })} jusqu'à&nbsp;
              {event.dateEnd.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
  })}
  </p>
      </div>
    </div>
    );
  })}
    </div>
  );
}